module.exports = __webpack_public_path__ + "media/application/images/svgs/file-minus-d5115c499f7eb6e48b6edcad4872f825.svg";